
import { Vue, Component } from 'vue-property-decorator'

import { tripModule, eventModule } from '@/store'
import { DistanceUnitMap, DistanceUnit } from '@/utils/enums'
import {
  LocalTripSettings,
  useLocalTripSettings,
} from '@/composables/trip-settings'

@Component({
  name: 'TripExportModal',
  setup() {
    const { tripSettings } = useLocalTripSettings(tripModule.trip!.id)

    return { tripSettings }
  },
})
class TripExportModal extends Vue {
  allFeaturesSelected = true
  tripSettings!: LocalTripSettings

  features = [
    { label: 'transportation.label', name: 'transportation', selected: true },
    { label: 'accommodation', name: 'accommodation', selected: true },
    { label: 'dailyPlan', name: 'dailyPlan', selected: true },
    { label: 'lists', name: 'lists', selected: true },
    { label: 'expenses', name: 'expenses', selected: true },
    { label: 'notes', name: 'notes', selected: true },
  ]

  get trip() {
    return tripModule.trip!
  }

  get selectAllBtnText(): string {
    return this.allFeaturesSelected
      ? this.$t('deselectAll').toString()
      : this.$t('selectAll').toString()
  }

  exportTrip() {
    const fields = this.features.reduce((items: any, feature) => {
      items[feature.name] = feature.selected
      return items
    }, {})

    const isDistanceUnit = (
      unit: string | null,
    ): unit is keyof typeof DistanceUnitMap => {
      return (
        !!unit && Object.values(DistanceUnit).includes(unit as DistanceUnit)
      )
    }

    const unit = isDistanceUnit(this.tripSettings.distanceUnit)
      ? DistanceUnitMap[this.tripSettings.distanceUnit]
      : DistanceUnitMap.kilometers

    fields.documents = false

    tripModule.exportTrip({
      tripId: this.trip.id,
      params: { fields, distanceUnit: unit },
    })
    this.closeDialog()

    setTimeout(() => {
      eventModule.toggleExportStartedPrompt()
    }, 500)
  }

  closeDialog(): void {
    this.$emit('update:value', false)
  }

  setAllCheckboxes(): void {
    this.features.forEach((feature) => {
      feature.selected = !this.allFeaturesSelected
    })

    this.allFeaturesSelected = !this.allFeaturesSelected
  }
}
export default TripExportModal
